// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gPpEwlARJRkIwYEbl0gwL","groupsList":"_1x163KY85kfHDKcY6pHXAO"};